import axios from 'axios';
import { AI_MODELS } from 'constants/api-endpoints';
import { AI_HEALTH_CHECK_URL } from 'constants/api-endpoints-external';

export const openaiAPI = {
  healthCheck: async () => {
    const res = await fetch(AI_HEALTH_CHECK_URL);

    if (!res.ok) {
      throw new Error('Please check the api status check url');
    }

    return res.json();
  },
};

export type ReasoningEffortTypes = 'high' | 'medium' | 'low';
export enum AIModelProvider {
  OPENAI = 'openai',
  BEDROCK = 'bedrock',
}
export interface AIModel {
  id: number;
  label: string;
  is_public: boolean;
  is_default: boolean;
  provider: AIModelProvider;
}
export const aiAPI = {
  getModels: () => axios.get<AIModel[]>(AI_MODELS).then((res) => res.data),
};
